<script setup>
// Tabela "atendente → ramal + senha" da aba Ligações SIP. Cada linha vira um ramal
// que o conector registra no PABX em nome do atendente (casado pelo e-mail dele).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import NextButton from 'dashboard/components-next/button/Button.vue';
import SipStatusBadge from './SipStatusBadge.vue';

const props = defineProps({
  agents: { type: Array, default: () => [] }, // atendentes da conta
  status: { type: Object, default: () => ({}) }, // ramal -> { state, error }
});
const rows = defineModel({ type: Array, default: () => [] });

const { t } = useI18n();

const INPUT_CLASS =
  'w-full px-3 py-2 text-sm border rounded-lg border-n-weak bg-n-alpha-1 text-n-slate-12';

// um atendente só pode aparecer uma vez
const disponiveis = row =>
  props.agents.filter(
    a => a.id === row.user_id || !rows.value.some(r => r.user_id === a.id)
  );
const podeAdicionar = computed(() => rows.value.length < props.agents.length);

const adicionar = () => {
  rows.value = [
    ...rows.value,
    {
      user_id: null,
      extension: '',
      auth_user: '',
      password: '',
      has_password: false,
    },
  ];
};
const remover = index => {
  rows.value = rows.value.filter((_, i) => i !== index);
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <div
      v-for="(row, index) in rows"
      :key="index"
      class="grid items-center grid-cols-[1fr_6rem_8rem_8rem_auto_auto] gap-2"
    >
      <select v-model="row.user_id" :class="INPUT_CLASS">
        <option :value="null" disabled>
          {{ t('INBOX_MGMT.SIP_PABX.AGENT_PLACEHOLDER') }}
        </option>
        <option v-for="a in disponiveis(row)" :key="a.id" :value="a.id">
          {{ a.name }} ({{ a.email }})
        </option>
      </select>
      <input
        v-model="row.extension"
        type="text"
        :placeholder="t('INBOX_MGMT.SIP_PABX.EXTENSION_LABEL')"
        :class="INPUT_CLASS"
      />
      <input
        v-model="row.auth_user"
        type="text"
        autocomplete="off"
        :placeholder="t('INBOX_MGMT.SIP_PABX.AUTH_USER_SHORT')"
        :class="INPUT_CLASS"
      />
      <input
        v-model="row.password"
        type="password"
        autocomplete="new-password"
        :placeholder="
          row.has_password
            ? t('INBOX_MGMT.SIP_PABX.PASSWORD_SET')
            : t('INBOX_MGMT.SIP_PABX.PASSWORD_LABEL')
        "
        :class="INPUT_CLASS"
      />
      <SipStatusBadge
        :state="status[row.extension]?.state"
        :error="status[row.extension]?.error"
      />
      <NextButton
        v-tooltip="t('INBOX_MGMT.SIP_PABX.REMOVE_AGENT')"
        icon="i-lucide-trash-2"
        slate
        ghost
        sm
        @click="remover(index)"
      />
    </div>
    <div>
      <NextButton
        :label="t('INBOX_MGMT.SIP_PABX.ADD_AGENT')"
        icon="i-lucide-plus"
        slate
        faded
        sm
        :disabled="!podeAdicionar"
        @click="adicionar"
      />
    </div>
  </div>
</template>
